import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNative = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V11C22 11.5523 21.5523 12 21 12C20.4477 12 20 11.5523 20 11V6H4V18H13C13.5523 18 14 18.4477 14 19C14 19.5523 13.5523 20 13 20H4ZM19 20C18.1667 20 17.4583 19.7083 16.875 19.125C16.2917 18.5417 16 17.8333 16 17C16 16.1667 16.2917 15.4583 16.875 14.875C17.4583 14.2917 18.1667 14 19 14C19.8333 14 20.5417 14.2917 21.125 14.875C21.7083 15.4583 22 16.1667 22 17C22 17.8333 21.7083 18.5417 21.125 19.125C20.5417 19.7083 19.8333 20 19 20Z" })
});
export default SvgNative;
